import React from "react";
import { CustomerDashboardIndex } from "../../../_metronic/_partials/customer-dashboard";

export const CustomerDashboard = () => {


    return (<><CustomerDashboardIndex /></>);
};